// extracted by mini-css-extract-plugin
export var breadcrumb = "_14-2";
export var breadcrumbArrow = "_14-3";
export var breadcrumbs = "_14-0";
export var link = "_14-4";
export var small = "_14-1";